import { render, staticRenderFns } from "./dataTabs.vue?vue&type=template&id=899ce3e8&"
import script from "./dataTabs.vue?vue&type=script&lang=js&"
export * from "./dataTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('899ce3e8')) {
      api.createRecord('899ce3e8', component.options)
    } else {
      api.reload('899ce3e8', component.options)
    }
    module.hot.accept("./dataTabs.vue?vue&type=template&id=899ce3e8&", function () {
      api.rerender('899ce3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/dataTabs.vue"
export default component.exports